import { render, staticRenderFns } from "./NoticesList.vue?vue&type=template&id=11618f73&scoped=true&"
import script from "./NoticesList.vue?vue&type=script&lang=js&"
export * from "./NoticesList.vue?vue&type=script&lang=js&"
import style0 from "./NoticesList.vue?vue&type=style&index=0&id=11618f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11618f73",
  null
  
)

export default component.exports